<template>
  <v-tooltip
    top
    max-width="500"
  >
    <template v-slot:activator="{ on: onTooltip }">
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        max-width="290px"
        min-width="290px"
        offset-y
        transition="scale-transition"
      >
        <template v-slot:activator="{ on: onMenu }">
          <div
            v-on="desabilitado ? { ...onTooltip } : { ...onMenu, ...onTooltip }"
          >
            <v-select
              ref="dataSelect"
              v-model="dataForm"
              :items="[dataForm]"
              :rules="rules"
              :label="label"
              prepend-icon="calendar_month"
              dense
              readonly
              :disabled="desabilitado"
            >
              <template v-slot:selection="data">
                <span>{{ data.item.visualizacao }}</span>
              </template>
              <template v-slot:append>
                <v-btn
                  icon
                  small
                  color="grey"
                  :disabled="desabilitado"
                  v-on="{ ...onMenu, ...onTooltip }"
                >
                  <v-icon small>
                    {{ menu ? "close" : "edit" }}
                  </v-icon>
                </v-btn>
              </template>
            </v-select>
          </div>
        </template>
        <v-date-picker
          v-model="dataSelecionada"
          :max="max"
          :min="min"
          year-icon="calendar_month"
          :type="tipo"
          :color="cor"
          @input="select"
        >
          <template v-slot:default>
            <v-spacer />
            <v-btn
              icon
              small
              color="error"
              class="mr-6"
              @click="toogle"
            >
              Fechar <v-icon small>
                close
              </v-icon>
            </v-btn>
          </template>
        </v-date-picker>
      </v-menu>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
import Data from '@/modules/data';

export default {
  name: 'AppDateSelect',

  props: {
    dataInicial: {
      type: String,
      default: '',
      required: false,
    },
    label: {
      type: String,
      default: 'Data',
      required: false,
    },
    tooltip: {
      type: String,
      default: 'Selecione a data',
      required: false,
    },
    min: {
      type: String,
      default: '',
      required: false,
    },
    max: {
      type: String,
      default: '',
      required: false,
    },
    rules: {
      type: Array,
      default: () => [(v) => !!v.valor || 'Selecione a data'],
      required: false,
    },
    desabilitado: {
      type: Boolean,
      default: false,
      required: false,
    },
    tipo: {
      type: String,
      default: 'date' /* [date] [month] */,
      required: false,
    },
    cor: {
      type: String,
      default: 'primary',
      required: false,
    },
    validate: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      dataSelecionada: this.dataInicial,
      menu: false,
    };
  },

  computed: {
    dataForm() {
      let visualizacao = '';
      if (this.tipo === 'month') {
        visualizacao = this.dataSelecionada ? Data.format(this.dataSelecionada, 'MM/YYYY') : '';
      } else if (this.dataSelecionada) {
        visualizacao = Data.compare('isValid', { a: this.dataSelecionada }) ? Data.format(this.dataSelecionada) : '';
      }
      return {
        visualizacao,
        valor: this.dataSelecionada,
      };
    },
  },

  watch: {
    dataInicial(value) {
      this.dataSelecionada = value;
    },
    validate(value) {
      if (value) {
        this.$emit('validate', false);
        this.$refs.dataSelect.validate();
      }
    },
  },

  methods: {
    select() {
      this.toogle();
      this.$emit('return', this.dataSelecionada);
    },
    toogle() {
      this.menu = !this.menu;
    },
  },
};
</script>
